module.exports = __webpack_public_path__ + "img/msx.91a0eca2.png";